// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearMore2 = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '23',
      height: '24',
      viewBox: '0 0 23 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.74997 9.62109C3.70497 9.62109 2.84997 10.487 2.84997 11.5454C2.84997 12.6038 3.70497 13.4698 4.74997 13.4698C5.79497 13.4698 6.64997 12.6038 6.64997 11.5454C6.64997 10.487 5.79497 9.62109 4.74997 9.62109Z',
      fill: 'white',
      stroke: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.05 9.62109C17.005 9.62109 16.15 10.487 16.15 11.5454C16.15 12.6038 17.005 13.4698 18.05 13.4698C19.095 13.4698 19.95 12.6038 19.95 11.5454C19.95 10.487 19.095 9.62109 18.05 9.62109Z',
      fill: 'white',
      stroke: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.4 9.62109C10.355 9.62109 9.49998 10.487 9.49998 11.5454C9.49998 12.6038 10.355 13.4698 11.4 13.4698C12.445 13.4698 13.3 12.6038 13.3 11.5454C13.3 10.487 12.445 9.62109 11.4 9.62109Z',
      fill: 'white',
      stroke: 'currentColor',
    }),
  );

export { IconLinearMore2 };
